import { render, staticRenderFns } from "./ReserveDeleteDialog.vue?vue&type=template&id=535ecb52&"
import script from "./ReserveDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./ReserveDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports